import React from 'react';
import Banner from 'components/Banner';
import Label from 'components/Label';
import NewsSlider from 'components/NewsSlider';
import TextWithIcon from 'components/TextWithIcon';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPost } from 'store/slices/BlogSlice';
import { selectPostsContent } from 'store/slices/BlogSlice';

const Article = () => {
    const { slug } = useParams();
    const dispatch = useDispatch();
    const postsContent = useSelector(selectPostsContent);

    // @ts-ignore
    // const { posts = [] } = useSelector(state => state?.news?.data?.data) || {};
    // const sliderPosts = posts?.filter(post => post.slug !== slug);

    const currentArticle = postsContent?.[slug] || {};

    React.useEffect(() => {
        dispatch(
            // @ts-ignore
            fetchPost({ slug }),
        );
    }, [dispatch, slug]);

    const {
        up_text = '',
        down_text = '',
        section_text = [],
        title,
        title_background,
        type,
        crated_at,
        time_to_read,
    } = currentArticle;

    const sectionBoxes = section_text
        .map(item => `<div class='box'><img src='${item.image}' alt='article-image' /><div>${item.text}</div></div>`)
        .join('');

    const content = `${up_text || ''}${sectionBoxes}${down_text || ''}`;

    return (
        <>
            <Banner image={title_background} buttonText="LEARN MORE">
                <Label>{type}</Label>
                <h2>{title}</h2>
                <div>
                    {crated_at && <TextWithIcon iconName="calendar" text={crated_at} />}
                    {time_to_read && <TextWithIcon iconName="clock" text={time_to_read} />}
                </div>
            </Banner>

            <article className="article-content" dangerouslySetInnerHTML={{ __html: content }}></article>
            {/* // TODO add correct posts */}
            {/* <NewsSlider data={sliderPosts} /> */}
        </>
    );
};

export default Article;
